var d=["abr","api","cdm","cdn","cmaf","csiwm","csvwm","dai","dash","dazn","dom","dpp","drm","dvr","eme","guid","hls","http","id","iso","ll","mp2","mp4","mpd","mpx","mse","ok","pin","ssai","sdk","ui","url","vod"];export{d as playbackAcronyms};
//# sourceMappingURL=playbackAcronyms.js.map
